export default __webpack_public_path__ + "static/media/pulses_received.cbda5f48.svg";